// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".not-found[data-v-5d1ee096]{height:100vh;height:calc(var(--vh, 1vh)*100);display:grid;grid-template-rows:1fr max-content}.not-found__content[data-v-5d1ee096]{align-self:center;display:grid;grid-auto-rows:max-content;justify-items:center;grid-gap:1rem;gap:1rem}.not-found__footer[data-v-5d1ee096]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
